import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { PgfnVO } from '../shared/model/pgfn-vo.model';
import { McticHttpClient } from '@mctic/ng-core';

@Injectable({
  providedIn: 'root'
})
export class PgfnService {

  private readonly service = '/sepin-backend/rest/proxy/pgfn';

  constructor(private readonly mcticHttp: McticHttpClient) { }

  verificarSituacaoEmpresa(cnpj: string): Observable<PgfnVO> {
    return this.mcticHttp.get<PgfnVO>(`${this.service}/divida-ativa/devedor/${cnpj}`);
  }

}
